import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(theme => ({
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    zIndex:1
  },

  title: {
    color:theme.palette.primary.main,
    fontSize: 100,
  },

  seconday: {
    fontSize: 50,
  },
}))

export default useStyles
